export default "__VITE_ASSET__DG83I$I7__"